import { render, staticRenderFns } from "./UnReadNotificationTable.vue?vue&type=template&id=fb3b01c4&scoped=true&lang=pug"
import script from "./UnReadNotificationTable.vue?vue&type=script&lang=ts"
export * from "./UnReadNotificationTable.vue?vue&type=script&lang=ts"
import style0 from "./UnReadNotificationTable.vue?vue&type=style&index=0&id=fb3b01c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3b01c4",
  null
  
)

export default component.exports